import gatewayServer, {concatPaths} from "./gatewayServer"

const contextPath = gatewayServer.gatewayBaseUrl + "/r2-server"
const servletPath = "/r2"
const services = {
    "edition.carrier-zone-speed": "/carrier-zone/speed",
    "edition.carrier-zone-operation": "/carrier-zone/operation",
    "edition.carrier-zone-max-value": "/carrier-zone/max-value",
    "edition.carrier-zone-blocked-vehicles": "/carrier-zone/blocked-vehicles",
    "edition.carrier-zone": "/carrier-zone",
    "edition.product-category": "/product-category",
    "edition.product": "/product",
    "edition.locality": "/locality",
    "edition.trip": "/trip",
    "trip.stops": "/trip/stops",
    "search.trip": "/trip",
    "edition.driver": "/driver",
    "edition.vehicle": "/vehicle",
    "edition.order": "/order",
    "edition.order-type": "/order-type",
    "edition.classification": "/classification",
    "edition.generic-attribute": "/generic-attribute",
    "edition.invoice": "/invoice",
    "edition.truck": "/truck",
    "edition.script": "/script",
    "edition.genericParamDefinition": "/generic-param-definition",
    "edition.automaticOptimization": "/automatic-optimization",

    "search.automaticOptimization": "/automatic-optimization",
    "search.carrier-zone-speed": "/carrier-zone/speed",
    "search.carrier-zone-operation": "/carrier-zone/operation",
    "search.carrier-zone-max-value": "/carrier-zone/max-value",
    "search.carrier-zone-blocked-vehicles": "/carrier-zone/blocked-vehicles",
    "search.carrier-zone": "/carrier-zone",
    "search.jobs": "/job",
    "search.product-category": "/product-category",
    "search.product": "/product",
    "search.invoice": "/invoice",
    "search.locality": "/locality",
    "search.payload-record": "/payload-record",
    "search.session-records": "/session-records",
    "search.unblockTripMessages": "/unblock/trip",
    "search.unreleaseTripMessages": "/unrelease/trip",
    "search.unblockCancelTripMessages": "/unblockCancel/trip",
    "search.driver": "/driver",
    "search.vehicle": "/vehicle",
    "search.truck": "/truck",
    "search.order": "/order",
    "search.order-type": "/order-type",
    "search.script": "/script",
    "search.genericParamDefinition": "/generic-param-definition",
    "search.classification": "/classification",
    "search.generic-attribute": "/generic-attribute",

    "city": "/city",
    "state": "/state",
    "country": "/country",
    "geocoding": "/geocoding",
    "google-maps": "/google-maps",
    "locality": "/locality",
    "user": "/user",
    "r2-all-users": "/user/find",
    "r2-all-users-restricted": "/user/find-restricted",
    "plate": "/plate",
    "driver": "/driver",
    "vehicle": "/vehicle",
    "vehicleFindAll": "/vehicle/find-all-vehicles",
    "order": "/order",
    "orderType": "/order-type",
    "productCategory": "/product-category",
    "product": "/product",
    "invoice": "/invoice",
    "restrictions": "/restrictions",
    "allowedOrigins": "/allowed-origins",
    "automaticOptimization": "/automatic-optimization",
    "userByOrigins": "/default-user-by-origin",
    "googleMaps": "/google-maps",
    "regionGroup": "/regionGroup",
    "classification": "/classification",
    "classification-type": "/classification-type",
    "generic-attribute": "/generic-attribute",
    "load-unload-duration": "/load-unload-duration",
    "integration-config": "/integration-config",
    "integration-config-update-all-url": "/integration-config/updateAllIntegrationUrls",
    "integration-connectivity": "/integration-connectivity",
    "integration-publishing-types": "/integration-config/publishing-types",
    "integration-get-publishing-type": "/integration-config/get-publishing-type",
    "transitions-config": "/transitions-config",

    "routeUrlForNodeIdentifier": "/route/nodeIdentifier",
    "routeUrlForTripIds": "/route/trips",

    "serverRouteOSM": "/osm/route-instructions",

    "calculateTollUrlForNodeIdentifier": "/toll/nodeIdentifier",
    "calculateFreightUrlForNodeIdentifier": "external-freight/nodeIdentifier",
    "selectExternalFreight": "external-freight/selectExternalFreight",
    "tripPickingListUrlForNodeIdentifier": "/trip-picking-list/nodeIdentifier",
    "tripPickingListExportAll": "/trip-picking-list/export-all",

    "alter-stops": "/alterStops/doAlterStops",
    "alter-stop-trips": "/alterStops/doAlterStopsForTrips",
    "move-stops": "/alterStops/moveStop",
    "move-trip-to-user": "/trip/toUser/",
    "move-deliveryunit-to-user": "/deliveryUnit/toUser/",
    "users": "users",

    "job-violations": "jobs/violations",
    "cancel-job": "jobs/cancel-job",
    "can-download-job": "jobs/can-download-job",
    "download-job": "jobs/download-job",

    "can-edit-trip": "/trip/can-edit",
    "edit-trip": "/trip/edit",
    "confirm-edition": "/trip/confirm-edition",
    "save-non-manual-operation": "/trip/saveNonManualOperation",

    "find-breaks": "/findBreaks",
    "resolve-order-break": "/resolveOrderBreak",
    "routingConfigSelector": "/routing-config-selector",

    "trip-publish": "/trip/publish",
    "trip-reprogram": "/trip/reprogram",
    "trip-serve": "/trip/serve",
    "status.trip": "trip/status",
    "session-trip-publish": "/session-trip/publish",

    "session-record": "session-record",
    "unblockTripMessages": "/unblock/trip",
    "unblockTripMessages-forceProcess": "/unblock/trip/forceProcessMessage",
    "unblockTripMessages-resendMessage": "/unblock/trip/resendMessage",
    "unreleaseTripMessages": "/unrelease/trip",
    "unreleaseTripMessages-forceProcess": "/unrelease/trip/forceProcessMessage",
    "unblockCancelTripMessages": "/unblockCancel/trip",
    "unblockCancelTripMessages-forceProcess": "/unblockCancel/trip/forceProcessMessage",

    "polygon-carrier-zone-groupers": "/carrier-zone-grouper/polygonCarrierZoneGroupers",

    "cancelTrips": "/programming/trip/cancel-trips",
    "canCancel": "/programming/trip/can-cancel",
    "finalize-trip": "/trip/finalize",

    "preValidation-manualOperation": "/pre-validation/manual-operation",
    "preValidation-optimization": "/pre-validation/optimization",
    "organize": "/organize",
    "organize-execute": "/organize/execute",

    "manualOperationSave": "/manual-operation/save",
    "geocodeLocalities": "/locality/geocoding",
    "existsAnyLocalityWithNoGeographicInfo": "/locality/exists-any-with-no-geographic-info",
    "geocodeLocalitiesWithNoGeographicInfo": "/locality/geocode-all-with-no-geographic-info",
    "system-version": "/system/version",
    "semantic-version": "semantic-version/full",

    "doOptimize": "/programming/optimization/do-optimize",
    "doOptimizeWithRestrictions": "/programming/optimization-with-restrictions/do-optimize",
    "getOriginsToOptimizeWithRestrictions": "/programming/optimization-with-restrictions/get-origins",

    "orderBasketUrl": "/basket/filter",
    "orderBasketSelectionUrl": "selection/basket/filter",

    "analysisMapMarkers": "/analysis-map/markers",
    "analysisMapOptimize": "/analysis-map/do-optimize",
    "analysisMapOptimizeWithRestrictions": "/analysis-map/do-optimize-with-restrictions",
    "analysisMapOptimizationPreValidation": "/analysis-map/optimization-pre-validation",
    "analysisMapOrdersDetails": "/analysis-map/orders-details",

    "current-user": "/authentication/current-user",

    "authorization": "/authorization",

    "query-report": "/transactional/report/query",

    "message-config-params": "/message-config-params",

    "vehicle-availability": "/vehicle-availability",

    "batch-edition-dto": "batchEdition/dto",
    "batch-edition": "batchEdition/do-batch-edition",
    "batch-edition-confirm-edition": "batchEdition/confirm-edition",

    // Parâmetros genéricos de localidade
    "search.incompatibleVehicle": "locality-incompatible-vehicles",
    "search.allowedPlate": "locality-allowed-plate",
    "search.serviceTime": "locality-service-time",

    "getFittingInformationsByTripAndOrderId": "/stopfit/getFittingInformationsByTripAndOrderId",
    "stopFitOrderPublish": "/stopfit/stopFitOrderPublish",

    "fitOrderInTrip": "/programming/stop-fill/execute?tripId=",
    "applyManualOperation": "/programming/stop-fill/save",

    "operation-overview": "/operation-overview",

    "truck-allocation": "/transactional/programming/truckallocation",
    "trucks": "/plate",

    "invoicesByNodeIdentifiers": "invoice/findByNodeIdentifiers",
    "findMonitorableSourceIdByNodeIdentifier": "delivery-overview-planning-link/find-monitorable-source-id-by-node-identifier",

    "startMonitorableConfigurationByNodeIdentifiers": "start-monitorable-configuration/findByNodeIdentifiers",
    "saveStartMonitorableConfiguration": "start-monitorable-configuration/save",
    "deleteStartMonitorableConfiguration": "start-monitorable-configuration/delete",

    "automaticOptimization.search": "/automatic-optimization/search",
    "automaticOptimization.new": "/automatic-optimization/new",

    "lgpd.entity.all": "/lgpd/entity/find-all",
    "lgpd.entity.anonymize": "/lgpd/entity/anonymize",
    "lgpd.entity.by-owner": "/lgpd/entity/entities-by-owner",
    "lgpd.entity.copy": "/lgpd/entity/copy",
    "lgpd.entity.edition": "/lgpd/entity",
    "lgpd.entity.filter": "/lgpd/entity",
    "lgpd.entity.versions": "/lgpd/entity/versions",
    "lgpd.entity.custom-filter": "/lgpd/entity/custom-filter",

    "lgpd.logs.allNames": "/lgpd/logs/all-names",
    "lgpd.logs.entitiesByName": "/lgpd/logs/entities-by-name",
    "lgpd.logs.find": "/lgpd/logs/find",
    "lgpd.logs.types": "/lgpd/logs/types",
    "lgpd.logs.exportDefinitions": "/lgpd/logs/export-definitions",

    "lgpd.obfuscate.allNames": "/lgpd/obfuscation/all-names",
    "lgpd.obfuscate.entitiesByName": "/lgpd/obfuscation/entities-by-name",
    "lgpd.obfuscate.find": "/lgpd/obfuscation/find",
    "lgpd.obfuscate.save": "/lgpd/obfuscation/save",

    "lgpd.attributable.all": "/lgpd/attributable/find-all",
    "lgpd.attributable.anonymize": "/lgpd/attributable/anonymize",
    "lgpd.attributable.edition": "/lgpd/attributable",
    "lgpd.attributable.filter": "/lgpd/attributable",

    "lgpd.classifiable.all": "/lgpd/classifiable/find-all",
    "lgpd.classifiable.anonymize": "/lgpd/classifiable/anonymize",
    "lgpd.classifiable.filter": "/lgpd/classifiable",
    "lgpd.classifiable.edition": "/lgpd/classifiable",

    "lgpd.genericParam.all": "/lgpd/generic-param/find-all",
    "lgpd.genericParam.anonymize": "/lgpd/generic-param/anonymize",
    "lgpd.genericParam.edition": "/lgpd/generic-param",
    "lgpd.genericParam.filter": "/lgpd/generic-param",

    "lgpd.sql.all": "/lgpd/script-sql/find-all",
    "lgpd.sql.copy": "/lgpd/script-sql/copy",
    "lgpd.sql.edition": "/lgpd/script-sql",
    "lgpd.sql.filter": "/lgpd/script-sql",
    "lgpd.sql.versions": "/lgpd/script-sql/versions",
    "lgpd.sql.r2-default": "/transactional/report/query/id",

    "config-params": "/config-params",
    "config-params.cache": "/config-params/cache",
    "config-params.check-for-script": "/config-params/check-for-script",
    "config-params.default-proxy": "/config-params/default-proxy",
    "config-params.default-remote-server": "/config-params/default-remote-server",
    "config-params.remote-config-params": "/config-params/remote-config-params",
    "config-params.test-routing-connection": "/config-params/test-routing-connection",
    "config-params.update": "/config-params/update",
    "config-params.update-ignoring-warnings": "/config-params/update/ignoring-warnings",
    "config-params.validate-remote-services": "/config-params/validate-remote-services",
    "config-params.get-path-provider-types": "/restrictions/path-provider/type",
    "config-params.get-path-provider-type": "/restrictions/path-provider",
    "config-params.set-path-provider": "/restrictions/path-provider",

    "orchestrator.remote-type-configuration": "/orchestrator/type-configurations",
    "orchestrator.create-remote-type-configuration": "/orchestrator/create-type-configuration",
    "orchestrator.get-mapped-machine-types": "/orchestrator/get-mapped-machine-types",
    "orchestrator.update-type-configuration": "/orchestrator/update-type-configuration",
    "orchestrator.test-routing-parallelism": "/orchestrator/test-routing-parallelism",
    "orchestrator.get-routing-availability": "/orchestrator/get-routing-availability",

    "services.notification.clear": "/notification",
    "services.notification.count": "/notification/count",
    "services.notification.notifications": "/notification",
    "services.notification.markConsumed": "/notification/markConsumed",
    "spreadsheet-integration": "/spreadsheet-integration",
    "new-spreadsheet-vehicle": "/vehicle/import",
    "new-spreadsheet-cancel-vehicle": "/vehicle/cancel-import",
    "new-spreadsheet-product": "/product/import",
    "new-spreadsheet-cancel-product": "/product/cancel-import",
    "new-spreadsheet-product-category": "/product-category/import",
    "new-spreadsheet-cancel-product-category": "/product-category/cancel-import",
    "new-spreadsheet-forbidden-vehicles": "/forbidden-vehicles/import",
    "new-spreadsheet-cancel-forbidden-vehicles": "/forbidden-vehicles/cancel-import",
    "new-spreadsheet-permitted-plates": "/permitted-plates/import",
    "new-spreadsheet-cancel-permitted-plates": "/permitted-plates/cancel-import",
    "spreadsheet-integration-error": "spreadsheet-integration-error",
    "new-spreadsheet-locality": "/locality/import",
    "new-spreadsheet-cancel-locality": "/locality/cancel-import",
    "new-spreadsheet-service-time": "/service-time/import",
    "new-spreadsheet-cancel-service-time": "/service-time/cancel-import",
    "new-spreadsheet-order": "/order/import",
    "new-spreadsheet-cancel-order": "/order/cancel-import",
    "new-spreadsheet-order-type": "/order-type/import",
    "new-spreadsheet-cancel-order-type": "/order-type/cancel-import",
    "new-spreadsheet-delete-order": "/order/delete",
    "new-spreadsheet-delete-locality": "/locality/delete",
    "new-spreadsheet-vehicle-availability": "/vehicle-availability/import",
    "new-spreadsheet-driver": "/driver/import",
    "new-spreadsheet-cancel-driver": "/driver/cancel-import",

    "purge-programming-database": "/database/purge",
    "purge-execution-database": "/database/purge-monitoring",

    "optimization-configuration-save": "/optimization-configuration/save",
    "optimization-configuration-find": "/optimization-configuration/find",

    "integration-configuration-save": "/integration-configuration/save",
    "integration-configuration-find": "/integration-configuration/find",

    "microstrategy-login": "/microstrategy/login",
    "microstrategy-logout": "/microstrategy/logout",
    "microstrategy-configuration": "/microstrategy/configuration",
    "microstrategy-is-allowed": "/microstrategy/is-allowed",
    "microstrategy-renew-session": "/microstrategy/renew-session",

    "external-freight-configuration": "external-freight-configuration/configurations",

    "script": "/script",
    "script-scriptValidator": "/script/validate",
    "script-scriptTypes": "/script/types",
    "script-requiredGenericParams": "/script/requiredparams",

    "genericParams": "/generic-param",
    "genericParamDefinitions": "/generic-param-definition",
    "genericParamComponents": "/generic-param/{definition-id}/components",

    "backgroundTaskJob": "background-task-job",
    "backgroundTaskJobCancel": "background-task-job/cancel/",
    "backgroundTaskJobDownload": "background-task-job/downloadTask/",
    "backgroundTaskJobCanDownload": "background-task-job/canDownloadTask/",
    "backgroundTaskJobViolations": "background-task-job/violations/",
    "backgroundTaskJobExportType": "background-task-job/getExportType/",

    "viaCepAddressByZipCode": "via-cep/address-by-zip-code/",

    "tripOperationHistoryUrlForNodeIdentifier": "/programming/trip/operationHistory/nodeIdentifier",

    "retrieve-providers": "/geocodification-provider-configuration/retrieve-providers",
    "retrieve-provider-by-permission-group": "/geocodification-provider-configuration/find-by-permission-group",
    "save-geocodification-providers-configuration": "/geocodification-provider-configuration/save",

    "here-maps": "/here-maps",

}

class ServerUrls<T extends Record<string, string>> {
    constructor(private contextPath: string, private servletPath: string, private services: T) {
    }

    getBaseUrl() {
        return this.contextPath + this.servletPath
    }

    getServiceUrl(service: keyof T) {
        const relativeUrl = this.getRelativeUrl(service)
        if (!relativeUrl) {
            return relativeUrl
        }
        return this.concatPaths(this.getBaseUrl(), relativeUrl)
    }

    getAutocompleteUrl(service: string) {
        const relativeUrl = this.getRelativeUrl(service)
        if (!relativeUrl) {
            return this.concatPaths(this.getBaseUrl(), service)
        }
        return this.concatPaths(this.getBaseUrl(), relativeUrl)
    }

    getRelativeUrl(service: keyof T) {
        if (!this.services[service]) {
            return ""
        }
        return this.services[service]
    }

    concatPaths(...paths: string[]) {
        return concatPaths(...paths)
    }
}

export const server = new ServerUrls(contextPath, servletPath, services)
export default server

export const integration = new ServerUrls(
    gatewayServer.gatewayBaseUrl + "/integration",
    "",
    {
        "cache": "cache",
        "validator": "validator",
        "validator.dataSources": "validator/data-sources",
        "validator.interfaces": "validator/interfaces",
    })